import { render, staticRenderFns } from "./SToolbar.vue?vue&type=template&id=620804e4&"
import script from "./SToolbar.vue?vue&type=script&lang=js&"
export * from "./SToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports